import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { generateUniqueId } from '../../../utils'
import { ToastType } from '../Toaster'

export interface ToasterState {
  toasts: ToastType[]
}

export const initialToasterState: ToasterState = {
  toasts: [],
}

export const toasterSlice = createSlice({
  initialState: initialToasterState,
  name: 'toaster',
  reducers: {
    addToastAction(
      state: ToasterState,
      { payload: toast }: PayloadAction<ToastType>,
    ) {
      state.toasts.push({ key: generateUniqueId(), ...toast })
    },

    removeToastAction(
      state: ToasterState,
      { payload: toast }: PayloadAction<ToastType>,
    ) {
      state.toasts = state.toasts.filter(i => i.key !== toast.key)
    },
  },
})

export default toasterSlice.reducer
